<template>
  <v-form
    ref="form"
    class="login-component mt-3"
    @submit.prevent="changePassword()"
  >
    <v-container>
      <v-layout
        row
        wrap
      >
        <v-flex
          class="py-0"
          xs12
        >
          <h1>{{ $t('app.login.firstAccessComponent.title') }}</h1>
        </v-flex>
        <v-flex
          class="pt-2 pb-0"
          xs12
        >
          <span class="subtitle">
            {{ $t('app.login.firstAccessComponent.subtitle') }}
          </span>
          <span class="subtitleComplement">
            {{ $t('app.login.firstAccessComponent.subtitleComplement') }}
          </span>
        </v-flex>
        <v-flex
          class="pt-0 pb-2"
          xs12
        >
          <span class="hint">{{ $t('app.login.firstAccessComponent.hint') }}</span>
        </v-flex>
        <v-flex xs12>
          <input-password
            v-model="payload.newPassword"
            required
            :rules="rulesPassword"
          />
        </v-flex>
        <v-flex
          class="py-0"
          xs12
        >
          <input-password
            v-model="payload.confirmNewPassword"
            required
            :rules="passwordConfirmationRules"
            :label="$t('app.login.firstAccessComponent.confirmPassword')"
          />
        </v-flex>
        <v-flex
          class="py-0"
          xs12
        >
          <btn-primary
            block
            type="submit"
            :disabled="enableSubmit"
            :text="$t('app.login.firstAccessComponent.enter')"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import InputPassword from 'Support/components/inputs/InputPassword.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import FormMixin from 'Support/components/crud/form-mixin';
import RecoverService from 'Domain/recoverPassword/RecoverService';
import { logout } from 'Support/services/login.service';

export default {
  name: 'FirstAccess',
  components: {
    BtnPrimary,
    InputPassword,
  },
  mixins: [RulesMixin, FormMixin],
  data() {
    return {
      payload: {
        newPassword: '',
        confirmNewPassword: '',
      },
      message: '',
      passwordConfirmationError: 'support.components.inputs.passwordConfirmation',
    };
  },
  computed: {
    passwordConfirmationRules() {
      return [
        this.minLength(8),
        this.maxLength(20),
        this.equalsToField(this.payload.newPassword, this.passwordConfirmationError),
      ];
    },
    rulesPassword() {
      return [
        this.minLength(8),
        this.maxLength(20),
        this.strongPassword,
      ];
    },
    enableSubmit() {
      return !(this.payload.newPassword && this.payload.confirmNewPassword);
    },
  },
  methods: {
    changePassword() {
      if (!this.validateForm()) {
        return;
      }
      RecoverService
        .changePasswordTemporary(this.payload)
        .then(() => {
          this.logoutSession();
        }).catch((response) => {
          this.message = response.message;
        });
    },
    logoutSession() {
      const loader = this.$loading.show();
      logout()
        .then(() => {
          this.navigateTo('FirstAccessSuccess');
          loader.hide();
        })
        .catch((response) => {
          this.message = response.message;
          loader.hide();
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
  .login-component
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .subtitle
      font-style normal
      font-weight normal
      font-size 14px
      color #113752
    .subtitleComplement
      font-style normal
      font-weight bold
      font-size 14px
      line-height 18px
      color #113752
    .hint
      font-style normal
      font-weight 600
      font-size 10px
      line-height 12px
      color #BDBDBD
</style>
